import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form2-container" }
const _hoisted_2 = { class: "editor-layout" }
const _hoisted_3 = { class: "form-area" }
const _hoisted_4 = { class: "rate-box" }
const _hoisted_5 = { class: "rate-tip" }
const _hoisted_6 = {
  key: 0,
  class: "question-branch"
}
const _hoisted_7 = { class: "single-uploader-card" }
const _hoisted_8 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_9 = { class: "hover-mask" }
const _hoisted_10 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_11 = {
  key: 1,
  class: "question-branch"
}
const _hoisted_12 = { class: "choice-card-header" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "options-container" }
const _hoisted_15 = { class: "opt-footer-actions" }
const _hoisted_16 = { class: "choice-actions" }
const _hoisted_17 = {
  key: 2,
  class: "question-branch"
}
const _hoisted_18 = { class: "ar-uploaders-row" }
const _hoisted_19 = { class: "single-uploader-card" }
const _hoisted_20 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_21 = { class: "hover-mask" }
const _hoisted_22 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_23 = { class: "single-uploader-card" }
const _hoisted_24 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_25 = { class: "hover-mask" }
const _hoisted_26 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_27 = { class: "single-uploader-card" }
const _hoisted_28 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_29 = { class: "hover-mask" }
const _hoisted_30 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_31 = { class: "preview-area" }
const _hoisted_32 = { class: "preview-header" }
const _hoisted_33 = { class: "mockup-phone" }
const _hoisted_34 = {
  key: 0,
  class: "phone-screen"
}
const _hoisted_35 = { class: "mock-nav" }
const _hoisted_36 = { class: "nav-title" }
const _hoisted_37 = { class: "screen-scrollable" }
const _hoisted_38 = { class: "mock-sub-row" }
const _hoisted_39 = { class: "diff-tag" }
const _hoisted_40 = { class: "mock-body-text" }
const _hoisted_41 = {
  key: 0,
  class: "mock-clue-card"
}
const _hoisted_42 = {
  key: 1,
  class: "phone-screen"
}
const _hoisted_43 = { class: "mock-nav" }
const _hoisted_44 = { class: "nav-title" }
const _hoisted_45 = {
  key: 0,
  class: "screen-scrollable"
}
const _hoisted_46 = { class: "choice-preview-title" }
const _hoisted_47 = { class: "choice-preview-options" }
const _hoisted_48 = { class: "opt-prefix" }
const _hoisted_49 = { class: "opt-txt" }
const _hoisted_50 = {
  key: 1,
  class: "screen-empty"
}
const _hoisted_51 = {
  key: 2,
  class: "phone-screen ar-mock-screen"
}
const _hoisted_52 = { class: "mock-nav" }
const _hoisted_53 = { class: "ar-viewfinder" }
const _hoisted_54 = { class: "scan-tip" }
const _hoisted_55 = {
  key: 0,
  class: "target-box"
}
const _hoisted_56 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "section-header" }, [
      _createElementVNode("h2", { class: "section-title" }, "关卡设计与谜题配置"),
      _createElementVNode("span", { class: "section-tip" }, "设计本关的目标题目、线索图与玩法类型，右侧实时同步 App 体验效果")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          "label-position": "top",
          rules: _ctx.rules,
          ref: "ruleForm",
          "status-icon": "",
          class: "custom-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "关卡标题",
              prop: "levelTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.levelTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.levelTitle) = $event)),
                  placeholder: "例如：古戏台的机关锁",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "关卡难度",
              prop: "difficulty"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_rate, {
                    modelValue: _ctx.form.difficulty,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.difficultyText), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "角色专属提示",
              prop: "selectRole"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.selectRole2,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectRole2) = $event)),
                  placeholder: "选择适用的角色",
                  multiple: "",
                  onChange: _ctx.valueChange,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_alert, {
                  title: "提示：可使用句号「。」作为不同角色线索的分隔标识",
                  type: "info",
                  closable: false,
                  class: "role-alert"
                }),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.roleTip,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.roleTip) = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "侦探角色提示。\n学者角色提示。",
                  maxlength: "500",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "题目类型",
              prop: "region"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.form.region,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.region) = $event)),
                  class: "type-radio-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { value: "填空题" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("填空题", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { value: "选择题" }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("选择题", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { value: "AR题" }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("AR 互动题", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.form.region === '填空题')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: "谜题正文描述",
                    prop: "levelContent"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.levelContent,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.levelContent) = $event)),
                        type: "textarea",
                        rows: 6,
                        maxlength: "800",
                        "show-word-limit": "",
                        placeholder: "请输入玩家需要阅读并解答的线索正文..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "谜题线索参考图",
                    prop: "levelCover"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_upload, {
                          class: "uploader-box",
                          action: _ctx.UpdateApi,
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          disabled: _ctx.allowUpload
                        }, {
                          default: _withCtx(() => [
                            (_ctx.form.levelCover)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_el_image, {
                                    src: _ctx.form.levelCover,
                                    class: "img-content",
                                    fit: "cover"
                                  }, null, 8, ["src"]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", {
                                      class: "del-btn",
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.clearImage('levelCover')), ["stop"])),
                                      title: "删除图片"
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(_component_el_icon, { class: "icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }),
                                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text" }, "上传线索图", -1)),
                                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                ]))
                          ]),
                          _: 1
                        }, 8, ["action", "on-success", "before-upload", "disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "标准答案设定（区分大小写或多答案关键词）",
                    prop: "levelDesc"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.levelDesc,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.levelDesc) = $event)),
                        type: "textarea",
                        rows: 3,
                        maxlength: "400",
                        "show-word-limit": "",
                        placeholder: "输入正确答案，玩家输入一致方可通关"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.region === '选择题')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_el_alert, {
                    title: "规则说明",
                    type: "warning",
                    description: "每道题目至少添加 2 个选项，并点击右侧单选框标记正确答案。",
                    closable: false,
                    class: "role-alert"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains, (domain, dIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: domain.key,
                      class: "choice-card"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, "第 " + _toDisplayString(dIndex + 1) + " 题", 1),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          link: "",
                          size: "small",
                          onClick: ($event: any) => (_ctx.removeDomain(domain))
                        }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode(" 删除题目 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createVNode(_component_el_form_item, { label: "题目题干" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: domain.value,
                            "onUpdate:modelValue": ($event: any) => ((domain.value) = $event),
                            placeholder: "请输入问题描述..."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "opt-label" }, "选项配置（选中即为正确答案）", -1)),
                        _createVNode(_component_el_radio_group, {
                          modelValue: domain.rightAnswer,
                          "onUpdate:modelValue": ($event: any) => ((domain.rightAnswer) = $event),
                          class: "opt-radio-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domain.options, (opt, oIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "option-row",
                                key: opt.id || oIndex
                              }, [
                                _createVNode(_component_el_radio, {
                                  value: opt.one,
                                  class: "opt-radio"
                                }, null, 8, ["value"]),
                                _createVNode(_component_el_input, {
                                  modelValue: opt.one,
                                  "onUpdate:modelValue": ($event: any) => ((opt.one) = $event),
                                  placeholder: "选项文字描述",
                                  class: "opt-input"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  link: "",
                                  icon: _ctx.Delete,
                                  class: "opt-del-btn",
                                  onClick: ($event: any) => (_ctx.deleteOption(domain, oIndex))
                                }, null, 8, ["icon", "onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            plain: "",
                            size: "small",
                            icon: _ctx.Plus,
                            onClick: ($event: any) => (_ctx.addOption(domain)),
                            disabled: domain.options && domain.options.length >= 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 增加选项 (" + _toDisplayString(domain.options ? domain.options.length : 0) + "/4) ", 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "onClick", "disabled"])
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _ctx.Plus,
                      onClick: _ctx.addDomain,
                      disabled: _ctx.domains.length >= 4
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 添加一道选择题 (" + _toDisplayString(_ctx.domains.length) + "/4) ", 1)
                      ]),
                      _: 1
                    }, 8, ["icon", "onClick", "disabled"]),
                    _createVNode(_component_el_button, { onClick: _ctx.resetForm }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("清空全部题目", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.region === 'AR题')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_el_form_item, {
                    label: "AR 谜题指引说明",
                    prop: "arQuestion"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.arQuestion,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.arQuestion) = $event)),
                        type: "textarea",
                        rows: 5,
                        maxlength: "500",
                        "show-word-limit": "",
                        placeholder: "引导玩家使用手机扫描实物目标的说明..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form_item, {
                      label: "目标识别图（现实物体/海报）",
                      class: "ar-upload-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_el_upload, {
                            class: "uploader-box",
                            action: _ctx.UpdateApi,
                            "show-file-list": false,
                            "on-success": _ctx.handleAvatarSuccess2,
                            "before-upload": _ctx.beforeAvatarUpload,
                            disabled: _ctx.allowUpload2
                          }, {
                            default: _withCtx(() => [
                              (_ctx.form.arImageRecognition)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_el_image, {
                                      src: _ctx.form.arImageRecognition,
                                      class: "img-content",
                                      fit: "cover"
                                    }, null, 8, ["src"]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("span", {
                                        class: "del-btn",
                                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.clearImage('arImageRecognition')), ["stop"])),
                                        title: "删除图片"
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_el_icon, { class: "icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text" }, "上传识别图", -1)),
                                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["action", "on-success", "before-upload", "disabled"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "AR 触发显示内容（叠加图）",
                      class: "ar-upload-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_upload, {
                            class: "uploader-box",
                            action: _ctx.UpdateApi,
                            "show-file-list": false,
                            "on-success": _ctx.handleAvatarSuccess3,
                            "before-upload": _ctx.beforeAvatarUpload,
                            disabled: _ctx.allowUpload3
                          }, {
                            default: _withCtx(() => [
                              (_ctx.form.arImageContent)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_el_image, {
                                      src: _ctx.form.arImageContent,
                                      class: "img-content",
                                      fit: "cover"
                                    }, null, 8, ["src"]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("span", {
                                        class: "del-btn",
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.clearImage('arImageContent')), ["stop"])),
                                        title: "删除图片"
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_component_el_icon, { class: "icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text" }, "上传内容图", -1)),
                                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["action", "on-success", "before-upload", "disabled"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "AR 触发显示内容（返回图）",
                      class: "ar-upload-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_el_upload, {
                            class: "uploader-box",
                            action: _ctx.UpdateApi,
                            "show-file-list": false,
                            "on-success": _ctx.handleAvatarSuccess4,
                            "before-upload": _ctx.beforeAvatarUpload,
                            disabled: _ctx.allowUpload4
                          }, {
                            default: _withCtx(() => [
                              (_ctx.form.arImageBack)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createVNode(_component_el_image, {
                                      src: _ctx.form.arImageBack,
                                      class: "img-content",
                                      fit: "cover"
                                    }, null, 8, ["src"]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("span", {
                                        class: "del-btn",
                                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.clearImage('arImageBack')), ["stop"])),
                                        title: "删除图片"
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createVNode(_component_el_icon, { class: "icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text" }, "上传内容图", -1)),
                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["action", "on-success", "before-upload", "disabled"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "badge-dot" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.form.region) + " · 移动端交互视口", 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "phone-top-bar" }, [
            _createElementVNode("div", { class: "notch" })
          ], -1)),
          (_ctx.form.region === '填空题')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowLeft)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.form.levelTitle || "关卡详情"), 1),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[30] || (_cache[30] = _createTextVNode(" 难度 ", -1)),
                      _createVNode(_component_el_rate, {
                        modelValue: _ctx.form.difficulty,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                        disabled: "",
                        size: "small"
                      }, null, 8, ["modelValue"])
                    ]),
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "recall-btn" }, "故事线索", -1))
                  ]),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.form.levelContent || "这里展示谜题具体内容与逻辑提示..."), 1),
                  (_ctx.form.levelCover)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "clue-tag" }, "关联线索", -1)),
                        _createVNode(_component_el_image, {
                          src: _ctx.form.levelCover,
                          fit: "cover",
                          class: "clue-img"
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "screen-footer" }, [
                  _createElementVNode("div", { class: "mock-input-mock" }, "输入你的答案..."),
                  _createElementVNode("button", { class: "mock-submit-btn" }, "验证答案")
                ], -1))
              ]))
            : (_ctx.form.region === '选择题')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_el_icon, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changePanel(0))),
                      class: "nav-action"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowLeft)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_44, "第 " + _toDisplayString(_ctx.selectNumber + 1) + "/" + _toDisplayString(_ctx.domains.length || 1) + " 题", 1),
                    _createVNode(_component_el_icon, {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changePanel(1))),
                      class: "nav-action"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRight)
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.domains.length > 0 && _ctx.domains[_ctx.selectNumber])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.domains[_ctx.selectNumber].value || "题目描述文字..."), 1),
                        _createElementVNode("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains[_ctx.selectNumber].options, (opt, oIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: oIndex,
                              class: _normalizeClass([
                    'mock-option-box',
                    { active: _ctx.domains[_ctx.selectNumber].rightAnswer === opt.one },
                  ])
                            }, [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(String.fromCharCode(65 + oIndex)), 1),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(opt.one || "选项内容..."), 1)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_50, "暂未添加选择题数据")),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "screen-footer" }, [
                    _createElementVNode("button", { class: "mock-submit-btn" }, "确认提交")
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowLeft)
                      ]),
                      _: 1
                    }),
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "nav-title" }, "AR 扫描互动", -1)),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "scan-grid" }, null, -1)),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.form.arQuestion || "请对准目标物体进行扫描识别"), 1),
                    (_ctx.form.arImageRecognition)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("img", {
                            src: _ctx.form.arImageRecognition,
                            alt: "AR Target"
                          }, null, 8, _hoisted_56)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "screen-footer" }, [
                    _createElementVNode("button", { class: "mock-submit-btn" }, "开始 AR 识别")
                  ], -1))
                ]))
        ])
      ])
    ])
  ]))
}